// Shared brand content for Venya Trade Enterprises.

export const CONTACT = {
  company: "Venya Trade Enterprises",
  parent: "Gupta Fruit Company",
  tagline: "Freshness isn't a promise — it's a legacy.",
  office: "78 New Vegetable Market, Sanour, Patiala",
  email: "venyatradeenterprises@gmail.com",
  phone: "+91 89681 60386",
  phoneHref: "+918968160386",
  hours: "Mon–Sat, mandi trading hours",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "What We Carry", to: "/products" },
  { label: "Sourcing Calendar", to: "/calendar" },
  { label: "Who We Serve", to: "/who-we-serve" },
  { label: "Contact", to: "/contact" },
];

export const PARTNERS = [
  { name: "Dole", src: "/logos/dole.jpg", dark: false },
  { name: "Zespri", src: "/logos/zespri.png", dark: false },
  { name: "Sunkist", src: "/logos/sunkist.jpg", dark: false },
  { name: "Fruitways", src: "/logos/fruitways.png", dark: true },
  { name: "Clee", src: "/logos/clee.jpg", dark: false },
  { name: "Magna", src: "/logos/magna.jpg", dark: false },
  { name: "Goodfarmer", src: "/logos/goodfarmer.jpg", dark: false },
  { name: "Frusan", src: "/logos/frusan.png", dark: false },
  { name: "Sweet C", src: "/logos/sweetc.png", dark: true },
  { name: "Enjoy", src: "/logos/enjoy.jpg", dark: false },
  { name: "Abacate International", src: "/logos/abacate.png", dark: true },
  { name: "Washington Apple", src: "/logos/washington.jpg", dark: false },
  { name: "Flash Gala", src: "/logos/flashgala.jpg", dark: false },
  { name: "Kromco", src: "/logos/kromco.jpg", dark: false },
  { name: "Melinda", src: "/logos/melinda.jpg", dark: false },
];

export const BUYER_PROMISE = [
  "One commission desk providing access to a broad portfolio of fruit families instead of relying on multiple individual suppliers.",
  "Indian harvests and import partners timed against each other to close seasonal gaps.",
  "Every lot inspected at the Patiala desk before it ships.",
  "Relationships with growers and importers built over two generations, not two seasons.",
];

export const HABITS = [
  {
    tag: "Checked",
    title: "Inspected before it ships",
    body: "Every lot is checked at the Patiala desk for grade, ripeness and size before it leaves for a buyer's dock.",
  },
  {
    tag: "Two Lines",
    title: "Indian harvest + imports",
    body: "Domestic growing regions and import partners are timed against each other, so most fruit families stay in supply most of the year.",
  },
  {
    tag: "Legacy",
    title: "Two generations of relationships",
    body: "Built on Gupta Fruit Company's grower and importer network — trust that took decades to earn, not build from scratch.",
  },
  {
    tag: "Priced Right",
    title: "Wholesale rates, retail-grade fruit",
    body: "Commission-desk pricing at APMC scale, without trading down on quality to hit a number.",
  },
];

export const PERSONAS = [
  {
    no: "01",
    kicker: "Fast-moving Retail",
    title: "Online grocery & quick-delivery platforms",
    intro: "For businesses that need fruit on shelves within hours, not days.",
    points: [
      "SKU-ready lots, graded and packed for fast turnover",
      "Short-notice dispatch to keep fill rates steady",
      "Consistent sizing and ripeness, batch to batch",
      "Backup sourcing lines so one origin's off-season doesn't stall your fill rate",
    ],
  },
  {
    no: "02",
    kicker: "Organised Retail",
    title: "Supermarkets & retail chains",
    intro: "For businesses buying at volume, across multiple stores and seasons.",
    points: [
      "Volume contracts across Indian and imported fruit",
      "Multi-origin backup — when one region's season ends, another begins",
      "Grading and quality documentation on request",
      "Category depth: 13 fruit families under one commission desk",
    ],
  },
  {
    no: "03",
    kicker: "Export & Institutional",
    title: "Foreign buyers & large-scale importers",
    intro: "For businesses sourcing container-scale volumes or entering the Indian market.",
    points: [
      "Direct lines into 19 Indian growing states, from Kashmir apples to Tamil Nadu avocados",
      "Import relationships across 21 countries to fill India's off-season gaps",
      "Consolidated lot sizing for container-scale orders",
      "Trade documentation and compliance support arranged on request",
    ],
  },
];

export const BUYER_TYPES = [
  "Online grocery / quick-delivery",
  "Supermarket / retail chain",
  "Wholesaler / distributor",
  "Exporter / importer",
  "Hotel / restaurant / institutional",
  "Other",
];

export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
